import React from 'react'
import PropTypes from 'prop-types'
import Loader from '../../../common/LoaderModule'
import yourDesignHere from '../../../../mocks/your-design-here'

import styles from './view.module.scss'

function View({src, alt, href, productName, loading = false}) {
    const yourDesignHereSrc = yourDesignHere[productName]
    return (
        <div className={styles.container}>
            {loading && <Loader className={styles.loader} />}
            <a href={href} className={styles.root}>
                <img
                    loading="lazy"
                    src={src}
                    alt={alt}
                    className={styles.image}
                />
                {yourDesignHereSrc && (
                    <img
                        loading="lazy"
                        src={yourDesignHereSrc}
                        alt="Добавьте свой текст или рисунок"
                        className={styles.yourDesignHere}
                    />
                )}
            </a>
        </div>
    )
}

View.propTypes = {
    productName: PropTypes.string,
    href: PropTypes.string,
    src: PropTypes.string,
    alt: PropTypes.string,
}

export default View
